import React, { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import "./Reactportal.scss";
import { IoMdCloseCircle } from "react-icons/io";
import SelectBranchInput from "../../Templets/SelectBranchInput/SelectBranchInput";
import { useModalContext } from "./ModalContext";
import { useEventListener } from "usehooks-ts";
import FocusTrap from "focus-trap-react";
import { useShortcut } from "react-keyhub";

interface ReactportalProps {
  id?: any;
  open?: any;
  children?: any;
  onClose?: any;
  TypeOfPortal?: any;
  TypeOfId?: any;
  UserRightsPortal?: any;
  FoooterContent?: any;
  Form_Key?: string | undefined;
  ShowBranchInput?: boolean | undefined;
  idTitle?: string | undefined;
  showCloseIcon?: boolean;
  AdditionalContent?: any

}

export default function Reactportal({
  id,
  open,
  children,
  onClose,
  TypeOfPortal = "View",
  TypeOfId,
  UserRightsPortal,
  FoooterContent = false,
  Form_Key = undefined,
  ShowBranchInput = false,
  idTitle = "",
  showCloseIcon = true,
  AdditionalContent = () => { }
}: ReactportalProps) {
  const { getTopModal, settings } = useModalContext();
  const modalRef = useRef<HTMLDivElement>(null);
  const [useFocusTrap, setUseFocusTrap] = useState(false);

  useShortcut("closeForm", (event: KeyboardEvent) => {
    event.preventDefault();
    if (getTopModal() === Form_Key && settings.enableshortcuts && !FoooterContent) {
      //Esc key
      onClose();
    }
  });
  useEffect(() => {
    if (modalRef.current) {
      modalRef.current.focus()
    }
  }, [])

  if (!open) return null;

  const content = (
    <div className="myModal" ref={modalRef} tabIndex={-1}>
      <div className={`${UserRightsPortal ? "rights-content modal-content" : "modal-content"}`}>
        {TypeOfPortal === "Confirm" ? (
          <div className="header">Confirmation</div>
        ) : (
          <div className="header">
            <div className="flex">
              <span></span>
              <span>{TypeOfPortal}</span>
            </div>
            <div className="flex">
              {ShowBranchInput && <SelectBranchInput Form_Key={Form_Key} TypeOfPortal={TypeOfPortal} />}
              {id ? (
                <span>
                  {idTitle}  {TypeOfId}
                </span>
              ) : (
                ""
              )}
              {AdditionalContent && AdditionalContent()}
              {showCloseIcon && (
                <span
                  onClick={() => {
                    onClose();
                  }}
                  className="closeIcon"
                >
                  <IoMdCloseCircle className="closeIcon" />
                </span>
              )}
            </div>
          </div>
        )}
        <div className={TypeOfPortal === "Confirm" ? "confirm content-container" : "content-container"}>{children}</div>
        {FoooterContent && FoooterContent}
      </div>
    </div>
  );

  return ReactDOM.createPortal(
    useFocusTrap ? <FocusTrap
      focusTrapOptions={{
        fallbackFocus: () => modalRef.current!,
        clickOutsideDeactivates: true,
        returnFocusOnDeactivate: false,
        allowOutsideClick: true,
      }}
    >
      {content}
    </FocusTrap>
      : content,
    document.getElementById("modal-root") as HTMLElement
  );
}
